import { render, staticRenderFns } from "./VacancyFormLanguage.vue?vue&type=template&id=cf916e4c"
import script from "./VacancyFormLanguage.vue?vue&type=script&lang=js"
export * from "./VacancyFormLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports